import PageLayout from "components/PageLayout";
import TorontoLogo from "assets/toronto_logo.png";
import PeelLogo from "assets/peel_logo.png";
import YorkLogo from "assets/york_logo.png";
import "./style.scss";

const AboutUs = () => {
  return (
    <PageLayout pageTitle="About Us">
      <p>
        The Sustainable Technologies Evaluation Program (STEP) is a multi-agency
        initiative developed to support broader implementation of sustainable
        technologies and practices within a Canadian context. STEP works to
        achieve this overarching objective by:
      </p>
      <ul>
        <li>
          {" "}
          Carrying out research, monitoring and evaluation of clean water and
          low carbon technologies;{" "}
        </li>
        <li>Assessing technology implementation barriers and opportunities;</li>
        <li>Developing supporting tools, guidelines and policies;</li>
        <li>Delivering education and training programs;</li>
        <li>Advocating for effective sustainable technologies; and</li>
        <li>
          Collaborating with academic and industry partners through our Living
          Labs and other initiatives.
        </li>
      </ul>
      <p>
        Technologies evaluated under STEP are not limited to physical devices or
        products; they may also include preventative measures, implementation
        protocols, alternative urban site designs, and other innovative
        practices that help create more sustainable and liveable communities.
      </p>
      <p>
        {" "}
        STEP also acts as a third party verifier for the Environmental
        Technology Verification (ETV) process. ETV provides independent
        evaluation of new technologies in order to validate environmental claims
        so that users, developers, regulators, and other parties can make
        informed decisions about purchasing, applying and regulating innovative
        technologies.
      </p>
      <p>STEP gratefully acknowledges base financial support from our municipal partners:</p>

      <div class="image-container">
          <img src={TorontoLogo} alt="City of Toronto" class="toronto-logo"/>
          <img src={PeelLogo} alt="Region of Peel" class="peel-logo"/>
          <img src={YorkLogo} alt="York Region" class="york-logo"/>
      </div>
      

    </PageLayout>
  );
};

export default AboutUs;
